import { jsx } from '@emotion/core';
import { isValidElement } from 'react';
import { ErrorIcon } from '../../Common';
import { ErrorContainer, ErrorText } from './styledComponents';

var FieldError = _ref => {
  var {
    children,
    icon,
    id,
    styleOverrides
  } = _ref;
  return jsx(ErrorContainer, {
    css: styleOverrides
  }, isValidElement(icon) ? icon : jsx(ErrorIcon, null), jsx(ErrorText, {
    id: id
  }, children));
};

export { FieldError };